import { Link } from 'react-router-dom';
import { pageMeta } from '../../constants/pageMeta';
import { COMPANY_NAME, SITE_NAME } from '../../constants/site';
import PolicyPage, { ContactBlock, List, Section } from '../components/PolicyPage';

const META = pageMeta(
  'Advertiser Disclosure',
  `How ${SITE_NAME} (${COMPANY_NAME}) earns money and how we advertise.`,
  '/advertiser-disclosure'
);

export default function AdvertiserDisclosurePage() {
  return (
    <PolicyPage
      title="Advertiser Disclosure"
      meta={META}
      intro={`We believe you should know how ${SITE_NAME} makes money and how that might affect what we recommend.`}
    >
      <Section title="1. How we earn money">
        <List
          items={[
            <>Service fees that you pay us for booking help, always shown before you pay (see <Link to="/service-fees">Service Fees</Link>).</>,
            'Commissions that some travel providers pay travel agencies when a booking is made. These do not increase the price you pay.',
            'Benefits available through our affiliation with Fora Travel, such as host-agency support and provider programmes.',
          ]}
        />
      </Section>

      <Section title="2. How recommendations are made">
        <p>
          Our advisors recommend options based on what you tell us: your dates, budget, preferences and the provider
          rules. Commission may differ between providers, but we will always show you the options that match your
          request and answer honestly if you ask how we are paid for a particular booking.
        </p>
      </Section>

      <Section title="3. How we advertise">
        <p>
          We advertise {SITE_NAME} on search engines and other websites, including through Google Ads. Our ads always
          promote {SITE_NAME} as an independent travel agency and are not ads for, or on behalf of, any airline or other
          travel provider. If you see an ad that suggests otherwise, please tell us.
        </p>
        <p>
          Advertising partners may use cookies to measure the results of our ads. See our{' '}
          <Link to="/cookie-policy">Cookie Policy</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>
      </Section>

      <Section title="4. No paid reviews">
        <p>We do not publish paid, invented or edited customer reviews on this website.</p>
      </Section>

      <Section title="5. Contact us">
        <ContactBlock />
      </Section>
    </PolicyPage>
  );
}
